import { render, staticRenderFns } from "./ViewEarthquakeReport.vue?vue&type=template&id=62f10ffc&scoped=true&"
import script from "./ViewEarthquakeReport.vue?vue&type=script&lang=js&"
export * from "./ViewEarthquakeReport.vue?vue&type=script&lang=js&"
import style0 from "./ViewEarthquakeReport.vue?vue&type=style&index=0&id=62f10ffc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f10ffc",
  null
  
)

export default component.exports